/** @format */

import {TFunction} from 'i18next';

const formatTimeFromMinutes = (totalMinutes: number, t: TFunction): string => {
  if (totalMinutes === 0) {
    return t('plurals.minutes', {count: 0});
  }

  const days = Math.floor(totalMinutes / 1440);
  const hours = Math.floor((totalMinutes % 1440) / 60);
  const minutes = totalMinutes % 60;

  const parts: string[] = [];

  if (days > 0) {
    parts.push(t('plurals.days', {count: days}));
  }

  if (hours > 0) {
    parts.push(t('plurals.hours', {count: hours}));
  }

  if (minutes > 0) {
    parts.push(t('plurals.minutes', {count: minutes}));
  }

  return parts.join(' ');
};

export {formatTimeFromMinutes};
